// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.me-show-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 0.75rem 1rem;
	background: rgb(0, 51, 51);
	border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.me-show-info {
	flex: 1;
	min-width: 0;
}

.me-show-name {
	font-size: 0.95rem;
	font-weight: 600;
	color: #fff;
	line-height: 1.2;
}

.me-show-meta {
	font-size: 0.72rem;
	color: rgba(255, 255, 255, 0.65);
	margin-top: 0.1rem;
}

.me-show-logo img {
	max-height: 40px;
	max-width: 56px;
	border-radius: 4px;
	object-fit: contain;
}

.me-page-title {
	display: block;
	font-size: 0.65rem;
	font-weight: 700;
	letter-spacing: 0.1em;
	color: #111827;
	text-transform: uppercase;
	margin-bottom: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/enter-horse-show-landing/enter-horse-show-landing.component.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,qBAAqB;CACrB,0BAA0B;CAC1B,4DAA4D;AAC7D;;AAEA;CACC,OAAO;CACP,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,yBAAyB;CACzB,sBAAsB;AACvB","sourcesContent":[".me-show-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 1rem;\n\tpadding: 0.75rem 1rem;\n\tbackground: rgb(0, 51, 51);\n\tborder-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;\n}\n\n.me-show-info {\n\tflex: 1;\n\tmin-width: 0;\n}\n\n.me-show-name {\n\tfont-size: 0.95rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tline-height: 1.2;\n}\n\n.me-show-meta {\n\tfont-size: 0.72rem;\n\tcolor: rgba(255, 255, 255, 0.65);\n\tmargin-top: 0.1rem;\n}\n\n.me-show-logo img {\n\tmax-height: 40px;\n\tmax-width: 56px;\n\tborder-radius: 4px;\n\tobject-fit: contain;\n}\n\n.me-page-title {\n\tdisplay: block;\n\tfont-size: 0.65rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.1em;\n\tcolor: #111827;\n\ttext-transform: uppercase;\n\tmargin-bottom: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
